import { useQuery } from '@tanstack/react-query';
import { apiService } from '../utils/serviceApi';

const fetchDriveoffStats = async (market, selectedGSZIds) => {
  const response = await apiService.post(
    `${process.env.REACT_APP_SERVICE_URL}/api/dashboard/gas-station-ranking-table-data`,
    {
      market,
      selectedGSZIds,
    }
  );
  return response.data;
};

export const useDriveoffStats = ({ market, selectedGSZIds, enabled = true }) => {
  return useQuery({
    queryKey: ['driveoffStats', market, selectedGSZIds],
    queryFn: () => fetchDriveoffStats(market, selectedGSZIds),
    enabled: enabled && Array.isArray(selectedGSZIds) && selectedGSZIds.length > 0,
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
